import { useCurrentUserQuery } from './api'

export type UserType = 'FOUNDER' | 'INVESTOR' | null

/**
 * Hook to get the current user's type (founder or investor).
 * Reads from the /users/me endpoint which includes userType.
 *
 * @returns The user type ('FOUNDER', 'INVESTOR', or null if not set)
 */
export function useUserType(): UserType {
  const { data } = useCurrentUserQuery()
  return data?.data?.userType ?? null
}

/**
 * Hook to check if the current user is a founder.
 */
export function useIsFounder(): boolean {
  const userType = useUserType()
  return userType === 'FOUNDER'
}

/**
 * Hook to check if the current user is an investor.
 */
export function useIsInvestor(): boolean {
  const userType = useUserType()
  return userType === 'INVESTOR'
}

/**
 * Hook to check if the current user is an admin.
 */
export function useIsAdmin(): boolean {
  const { data } = useCurrentUserQuery()
  return data?.data?.role === 'ADMIN'
}
